// extracted by mini-css-extract-plugin
export default {"card":"WxtZ7tKnjY7g2sC1wUQR"};